export const convertToKebabCase = (string) => {
  return string.split(' ').join('-').toLowerCase();
};

export const convertToInitialCaps = (string) => {
  return string
    .split('-')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
};

const ratio = 1.37;
export const calculateBoardSize = (height, width) => {
  const landscape = width > height;

  if (landscape) {
    const boardHeight = height;
    const boardWidth = boardHeight * ratio;
    const blockSize = boardWidth / 40;

    return { boardHeight, boardWidth, blockSize };
  }

  const boardWidth = width;
  const boardHeight = boardWidth / ratio;
  const blockSize = boardWidth / 40;

  return { boardHeight, boardWidth, blockSize };
};
